export const config = {
    // APP_PROJECT_MANAGEMENT_URL: "https://backend.shahiapps.in/api",
    whatsapp_redirection_url: 'http://dev.schemaxtech.in/#',
    whatsapp_notification_url: 'http://206.189.138.212:3000',
    whatsapp_broadcast_url: 'http://206.189.138.212:3232/api',

    //APP_PROJECT_MANAGEMENT_URL: "http://localhost:9023/api",
      APP_PROJECT_MANAGEMENT_URL: "http://165.22.220.143:9032/api",
    APP_IAM_SERVER_URL: "https://ums-backend.shahiapps.in/",
    APP_IAM_CLIENT_ID: "225ba80a-3678-4a37-891e-4a55079df157",
}
